import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import {parseUrlParameters} from '@src/utils.mjs';

Vue.use(Vuex);

export default (config) => new Vuex.Store({
	state: {
		grpid: config.grpid,
		fldid: config.fldid,
		dataid: config.dataid,

		cafeRoles: config.cafeRoles,

		type: config.type,

		query: config.query || '',
		searchCtx: config.searchCtx || '',
		isNicknameSearch: config.isNicknameSearch || false,

		title: config.title || '',
		description: config.description || '',

		isAnonymous: config.isAnonymous || false,

		plainRegdt: config.plainRegdt || '',

		contentval: config.contentval || '',
		firstBbsDepth: config.firstBbsDepth || '',
		lastBbsDepth: config.lastBbsDepth || '',

		params: parseUrlParameters(),

		articles: [],

		userId: config.userId,
		isAdmin: config.isAdmin,
		isBoardAdmin: config.isBoardAdmin,
		rolecode: config.rolecode,

		page: config.page || 0,
		prevPage: config.prevPage || 0,
		listNum: config.listNum || 20,
	},
	getters: {
		isSearch({type}) {
			return type === 'search';
		},
		isRecent({type}) {
			return type === 'recent';
		},
		isFavor({type}) {
			return type === 'favor';
		},
		isAlbum({type}) {
			return type === 'album';
		},
		isArticle({type}) {
			return type === 'article';
		},
		fetchOptions(state, {isSearch, isRecent, isFavor, isAlbum}) {
			const url = isSearch ? '/_c21_/search/articles' : '/_c21_/bottom/articles';
			if (isSearch) {
				return {
					url: url,
					params: {
						grpid: state.grpid,
						fldid: state.fldid,
						searchCtx: state.searchCtx,
					}
				};
			}

			if (isRecent) {
				return {
					url: url,
					params: {
						grpid: state.grpid,
						fldid: state.fldid,
						dataid: state.dataid,
						type: state.type,
						regdt: state.plainRegdt
					}
				};
			}

			if (isFavor) {
				return {
					url: url,
					params: {
						grpid: state.grpid,
						fldid: state.fldid,
						dataid: state.dataid,
						type: state.type,
						regdt: state.params.favorRegdate,
						mode: state.params.favorMode
					}
				};
			}

			if (isAlbum) {
				return {
					url: url,
					params: {
						grpid: state.grpid,
						fldid: state.fldid,
						dataid: state.dataid,
						type: state.type,
						contentval: state.contentval
					}
				};
			}

			return {
				url: url,
				params: {
					grpid: state.grpid,
					fldid: state.fldid,
					contentval: state.contentval
				}
			};
		}
	},
	mutations: {
		setArticles(state, articles) {
			state.articles = [...articles];
		}
	},
	actions: {
		async fetchArticles({commit, getters}) {
			const {fetchOptions} = getters;
			const {url, params} = fetchOptions;

			const {data} = await axios.get(url, {params: params});
			commit('setArticles', data.articles);
		}
	}
});
